<template>
  <!-- for scroll position -->
  <div ref="scrollToElement" />
  <filter-header
    :show-filter-mode="showFilterMode"
    :toggle-show-mode="toggleShowMode"
    :has-filter="hasFilter"
    :clear-all-filter="clearAllFilter"
    :total-record="mediaStats?.page?.totalRecord"
  >
    <template #query-fields>
      <div class="control is-expanded">
        <SingleCountDropdown
          v-model="queryParam.category"
          :label="$t('media.column.category')"
          :stats="tagOptions?.category"
          @update:model-value="updateFilter"
        />
      </div>
      <div class="control is-expanded">
        <SingleCountDropdown
          v-model="queryParam.subject"
          :label="$t('media.column.subject')"
          :stats="tagOptions?.subject"
          @update:model-value="updateFilter"
        />
      </div>
      <div
        v-if="false"
        class="control is-expanded"
      >
        <SingleCountDropdown
          v-model="queryParam.media"
          :label="$t('media.column.media')"
          :stats="tagOptions?.media"
          @update:model-value="updateFilter"
        />
      </div>
      <div class="control is-expanded searchWrap">
        <selection-input
          v-model="queryParam.searchText"
          :label="$t('common.search')"
          @update:model-value="updateSearchKey"
        />
      </div>
    </template>
    <!-- end of selection input box -->
    <template #query-display>
      <template
        v-for="(field, fieldKey) in mediaDisplayLabelForQuery"
        :key="'query' + fieldKey"
      >
        <ShowQueryText
          :field-key="fieldKey"
          :label="field.label"
          :query-param="queryParam"
          :clear-query-item="clearQueryItem"
          :class-style="'tag is-light filter ' + field.css"
        />
      </template>
    </template>
  </filter-header>

  <MediaList
    :featured-list="featuredList"
    :unfeatured-list="unfeaturedList"
    :query-param="queryParam"
    :total-record="mediaStats.page?.totalRecord"
    :has-filter="hasFilter"
    :default-image-urls="defaultImageUrls"
  >
    <!-- <template #top-pagination>
      <common-pagination
        :total-page-in-view="pageInView"
        :total-page="mediaStats.page?.totalPage ?? 1"
        :current-page-number="queryParam?.page ?? 1"
        :additional-action="scrollToTop"
        :update-page="updatePage"
      />
    </template> -->
    <template #bottom-pagination>
      <common-pagination
        :total-page-in-view="pageInView"
        :total-page="mediaStats.page?.totalPage ?? 1"
        :current-page-number="queryParam?.page ?? 1"
        :additional-action="scrollToTop"
        :update-page="updatePage"
      />
    </template>
  </MediaList>
  <div
    v-show="isLoading"
    class="data-loader-inside"
  />
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import { mediaSearchState } from '@/composables/state/mediaSearchApp';
import FilterHeader from '../../components/FilterHeader.vue';
// import CustomDropdown from '../../components/dropdown/CustomDropdown.vue';
import SingleCountDropdown from '../../components/dropdown/SingleCountDropdown.vue';
import SelectionInput from '../../components/search/SelectionInput.vue';

import CommonPagination from '../../components/CommonPagination.vue';
import ShowQueryText from '../../components/ShowQueryText.vue';
import MediaList from './MediaList.vue';
import { mediaDisplayLabelForQuery } from '@/config/index';

const props = defineProps({
  userInput: { type: Object, default: () => { return {}; } },
});

const {
  mediaList, queryParam, tagOptions, mediaStats, clearQueryItem, clearAllFilter, updatePage, isLoading,
} = mediaSearchState();

const defaultImageUrls = computed(():Record<string, string> => {
  const placeHolderImages:Record<string, string> = {};
  Object.keys(props.userInput).forEach(k => {
    if (k.startsWith('image')) {
      placeHolderImages[k.substring('image'.length).toLowerCase()] = props.userInput[k];
    }
  });

  return placeHolderImages;
});
// console.log({ tagOptions, key: Object.keys(tagOptions.value.category) });
// const searchText = ref('');
const updateSearchKey = (e:string) => {
  queryParam.value.page = 1;
  queryParam.value.searchText = e;
};
const toggleShowMode = () => {
  showFilterMode.value = !showFilterMode.value;
};
const updateFilter = () => {
  queryParam.value.page = 1;
};

const hasFilter = computed(():boolean => {
  return (queryParam.value != null) && (
    (queryParam.value?.category != null || queryParam.value?.media != null || queryParam.value.subject != null ||
    ((queryParam.value.searchText ?? '').length > 0) ||
    queryParam.value.postedBy != null || queryParam.value.tags != null));
});

const featuredList = computed(() => {
  return mediaList.value.filter((x:any) => { return !!x.isFeatured; });
});
const unfeaturedList = computed(() => {
  return mediaList.value.filter((x:any) => !x.isFeatured);
});
const pageInView = 5;

const showFilterMode = ref(true);
const scrollToElement = ref<HTMLInputElement | null>(null);

const scrollToTop = () => {
  if (scrollToElement.value) {
    scrollToElement.value.scrollIntoView({ behavior: 'smooth' });
  }
};

</script>
<style lang="postcss">
section.mediaFilters .filterWrap .control:nth-child(3) {
      width: 20%;
  }
  section.mediaFilters .control:nth-child(4) {
    width: 30%;
  }
  .sort-select {
    width: 250px;
  }
  section.mediaFilters .hide {
    display: none!important;
  }
  .cross.closed>span>span:first-child {
  display: none;
}
section.mediaFilters >>> .filter.media {
  background-color: #795548;
}
section.publicationFilters .filterWrap .control {
  width: 20%;
}

</style>
